@if (viewers().length || lockedByOther()) {
  <div class="deal-presence">
    <button
      type="button"
      class="deal-presence__chip"
      [class.deal-presence__chip--attention]="attention()"
      [class.deal-presence__chip--locked]="lockedByOther()"
      [attr.aria-label]="ariaLabel()"
      [ngbPopover]="viewersPopover"
      [container]="'body'"
      triggers="mouseenter:mouseleave focusin:focusout"
      placement="bottom-end bottom-start bottom"
      popoverClass="deal-presence-popover"
    >
      @if (lockedByOther()) {
        <i class="bi bi-lock-fill deal-presence__lock" aria-hidden="true"></i>
      } @else {
        <span class="deal-presence__live" aria-hidden="true"></span>
      }
      <span class="deal-presence__faces" aria-hidden="true">
        @for (viewer of faces(); track viewer.userId) {
          <span class="deal-presence__face" [ngClass]="viewer.fill">{{ viewer.initials }}</span>
        }
        @if (overflow()) {
          <span class="deal-presence__more">+{{ overflow() }}</span>
        }
      </span>
      <span class="deal-presence__label" aria-hidden="true">{{ label() }}</span>
    </button>

    <span class="visually-hidden" aria-live="polite">{{ ariaLabel() }}</span>
  </div>
}

<ng-template #viewersPopover>
  <span class="deal-presence-viewers__heading">Viewing now</span>
  <ul class="deal-presence-viewers list-unstyled">
    @for (viewer of viewers(); track viewer.userId) {
      <li class="deal-presence-viewers__item">
        <span class="deal-presence-viewers__face" [ngClass]="viewer.fill">{{ viewer.initials }}</span>
        <span class="deal-presence-viewers__name">{{ viewer.displayName }}</span>
      </li>
    }
  </ul>
</ng-template>
